<template>
  <div class="h-full">
    <survey-container class="h-full">
      <template v-slot:left>
        <sample-survey-left />
      </template>
      <template v-slot:default>
        <sample-survey-main />
      </template>
      <template v-slot:right>
        <sample-survey-right />
      </template>
    </survey-container>
  </div>
</template>

<script>
import SurveyContainer from '@/components/survey/SurveyContainer'
import SampleSurveyRight from './components/SampleSurveyRight'
import SampleSurveyLeft from './components/SampleSurveyLeft'
import { getSurveyById } from '@/api/survey'
import GlobalConfig from '@/global/config'
import SampleSurveyMain from '@/views/other-pages/sample-company/components/SampleSurveyMain'

export default {
  name: 'SampleAttr',
  components: { SampleSurveyMain, SampleSurveyLeft, SampleSurveyRight, SurveyContainer },
  created() {
    const loading = this.$loading({
      text: '正在加载问卷数据',
      background: 'rgba(0,0,0,0.65)'
    })
    this.initSurvey().finally(() => {
      loading.close()
    })
  },
  methods: {
    initSurvey() {
      GlobalConfig.setSurveyId(this.$route.query.surveyId)
      return getSurveyById(GlobalConfig.getSurveyId()).then(res => {
        return this.$store.dispatch('initSurvey', res.data.data)
      })
    }
  }
}
</script>

<style scoped></style>
